<template>
    <label class="block mt-3 relative">
        <div v-if="disableFroala" class="z-50 absolute top-0 left-0 right-0 bottom-0">
            <!-- This is a blocker to "disable" the froala editor -->
        </div>
        <div class="flex justify-between">
            <span class="text-gray-700 dark:text-gray-200">{{ label }}</span>
        </div>

        <input type="text" class="hidden" />

        <content-editor
            :disabled="disableFroala"
            class="mt-1"
            @input="(val) => $emit('input', val)"
            :value="value"
            :name="name"
            :id="id"
            :content-data="value"
            :toolbarButtons="toolbarButtons"
            :table-max-cols="tableMaxCols"
            :language="language"
            :maxlength="maxlength"
        />

        <slot></slot>

        <error class="mt-1" :error="error" />
    </label>
</template>

<script>
import siteLanguage from '../../config/siteLanguage'
import {useFroalaStore} from "../../stores/froala";

export default {
    name: "InputRichText",
    props: {
        value: String,
        name: String,
        label: String,
        id: String,
        editor: String,
        language: {
            type: Object,
            default: () => {
                return { iso: siteLanguage.iso.ENGLISH };
            },
        },
        tableMaxCols: {
            type: Number,
            required: false,
            default: 10,
        },
        error: {
            type: String,
            required: false,
        },
        toolbarButtons: {
            type: Array,
            required: false,
            default: () => [
                'rocketLink',
                'italic',
                'formatOL',
                'formatUL',
                'bold',
                'underline',
                'strikeThrough',
                'subscript',
                'superscript',
                'undo',
                'redo',
                'clearFormatting',
                'html'
            ],
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        maxlength: {
            type: Number,
            required: false,
        },
    },
    data(){
        return {
            froalaStore: useFroalaStore(),
        }
    },
    computed: {
        disableFroala() {
            return this.disabled || this.froalaStore.disableFroala;
        },
    },
};
</script>
